import { gql } from '@apollo/client';
export const REPORT_TEMPLATE_FIELDS = gql `
  fragment ReportTemplateFields on ReportTemplate {
    id
    createdAt
    updatedAt
    clientId
    name
    type
    settings
    integrationConfigId
    isActive
    showInDashboard
    lastRunStatus
    lastRunAt
    cronSchedules
    publicKey
    shortName
    filenamePattern
    extension
    startDate
    daysApart
  }
`;
export const REPORT_TEMPLATES = gql `
  ${REPORT_TEMPLATE_FIELDS}
  query REPORT_TEMPLATES($spec: ReportTemplateSpec!) {
    reportTemplates(spec: $spec) {
      ...ReportTemplateFields
    }
  }
`;
export const GET_REPORT_TEMPLATE = gql `
  ${REPORT_TEMPLATE_FIELDS}
  query GET_REPORT_TEMPLATE($id: Int!) {
    getReportTemplate(id: $id) {
      ...ReportTemplateFields
    }
  }
`;
export const TEST_REPORT_TEMPLATE = gql `
  query TEST_REPORT_TEMPLATE($input: ReportTemplateInput!, $pagination: PaginationInput!) {
    testReportTemplate(input: $input, pagination: $pagination) {
      total
      page
      pageSize
      items
    }
  }
`;
export const GET_REPORT_COLUMNS = gql `
  query GET_REPORT_COLUMNS($input: ReportTemplateInput!) {
    getReportColumns(input: $input) {
      category
      categoryCode
      label
      code
      default
      sortOrder
      localize
    }
  }
`;
export const DOWNLOAD_REPORT = gql `
  query DOWNLOAD_REPORT($input: ReportTemplateInput!) {
    downloadReport(input: $input)
  }
`;
export const SAVE_REPORT_TEMPLATE = gql `
  ${REPORT_TEMPLATE_FIELDS}
  mutation SAVE_REPORT_TEMPLATE($input: ReportTemplateInput!) {
    saveReportTemplate(input: $input) {
      ...ReportTemplateFields
    }
  }
`;
export const DELETE_REPORT_TEMPLATE = gql `
  ${REPORT_TEMPLATE_FIELDS}
  mutation DELETE_REPORT_TEMPLATE($id: Int!) {
    deleteReportTemplate(id: $id) {
      ...ReportTemplateFields
    }
  }
`;
